"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/KeyTokenByUUIDAndSerID");
var ModalDetailTokenComponent_1 = require("./ModalDetailTokenComponent");
var jwt_decode_1 = require("jwt-decode");
var reactstrap_1 = require("reactstrap");
var KeyTokenTableComponent = /** @class */ (function (_super) {
    __extends(KeyTokenTableComponent, _super);
    function KeyTokenTableComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.setTokenExpired = function (token) {
            var decoded = jwt_decode_1.default(token);
            var timeExpired = new Date(decoded.exp * 1000);
            var msDiff = timeExpired.getTime() - new Date().getTime();
            var daysTill30June2035 = Math.floor(msDiff / (1000 * 60 * 60 * 24));
            if (daysTill30June2035 > 30) {
                return React.createElement("span", null,
                    timeExpired.toDateString(),
                    " (",
                    React.createElement("span", { style: { color: "" } },
                        daysTill30June2035,
                        " day"),
                    ")");
            }
            else if (daysTill30June2035 < 30 && daysTill30June2035 > 0) {
                return React.createElement("span", null,
                    timeExpired.toDateString(),
                    " (",
                    React.createElement("span", { style: { color: "orange" } },
                        daysTill30June2035,
                        " day"),
                    ")");
            }
            else if (daysTill30June2035 < 0) {
                return React.createElement("span", null,
                    timeExpired.toDateString(),
                    " (",
                    React.createElement("span", { style: { color: "red" } },
                        daysTill30June2035,
                        " day"),
                    ")");
            }
        };
        _this.state = {
            pageLoad: true,
            isOpenModal: false,
            keyUUID: "",
            keyName: "",
            appId: "",
            serviceId: ""
        };
        _this.onClickTr = _this.onClickTr.bind(_this);
        _this.afterOpenModal = _this.afterOpenModal.bind(_this);
        _this.afterCloseModal = _this.afterCloseModal.bind(_this);
        return _this;
    }
    KeyTokenTableComponent.prototype.onClickTr = function (e) {
        this.setState({
            pageLoad: false,
            isOpenModal: true,
            keyUUID: e.currentTarget.dataset.keyuuid,
            keyName: e.currentTarget.dataset.keyname
        });
    };
    KeyTokenTableComponent.prototype.afterOpenModal = function () {
        this.setState({
            isOpenModal: false
        });
    };
    KeyTokenTableComponent.prototype.afterCloseModal = function () {
        this.setState({
            pageLoad: true
        });
    };
    KeyTokenTableComponent.prototype.render = function () {
        var _this = this;
        var isOpenModal = this.state.isOpenModal;
        var keyUUID = this.state.keyUUID;
        var keyName = this.state.keyName;
        //console.log("- app Id - " + this.props.appId);
        //console.log("- service - " + this.props.serviceId);
        if (this.props.appId != "" && this.props.serviceId != "" && (this.props.appId != this.state.appId || this.props.serviceId != this.state.serviceId)) {
            this.props.requestFunction(this.state.pageLoad, this.props.appId, this.props.serviceId, this.props.getToken);
            this.setState({
                appId: this.props.appId,
                serviceId: this.props.serviceId
            });
        }
        if (this.props.getToken) {
            console.log("- getToken - " + this.props.getToken);
            this.props.requestFunction(this.state.pageLoad, this.props.appId, this.props.serviceId, this.props.getToken);
            this.props.setGetTokenFalse();
        }
        if ((this.props.isLoading && this.props.response.result_list != undefined)) {
            console.log(this.props.response.result_list);
        }
        return (React.createElement("div", { className: "form-group" },
            React.createElement("table", { className: 'table table-bordered' },
                React.createElement("thead", null,
                    React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                        React.createElement("td", null, "Key UUID"),
                        React.createElement("td", null, "Key Name"),
                        React.createElement("td", null, "Created By"),
                        React.createElement("td", null, "Create On"),
                        React.createElement("td", null, "Token Expired"))),
                React.createElement("tbody", null,
                    (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                        return React.createElement("tr", { key: item.key_uuid, className: "table-tbody", "data-keyuuid": item.key_uuid, "data-keyname": item.key_name, onClick: _this.onClickTr },
                            React.createElement("td", null, item.key_uuid),
                            React.createElement("td", null, item.key_name),
                            React.createElement("td", null, item.created_by),
                            React.createElement("td", null, item.created_on),
                            React.createElement("td", null, _this.setTokenExpired(item.access_token)));
                    }),
                    !this.props.isLoading ? React.createElement("tr", null,
                        React.createElement("td", { colSpan: 5, style: { background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" } },
                            "Loading...",
                            React.createElement(reactstrap_1.Spinner, null),
                            " ")) : '')),
            React.createElement(ModalDetailTokenComponent_1.default, { afterOpenModal: this.afterOpenModal.bind(this), afterCloseModal: this.afterCloseModal.bind(this), isOpenModal: isOpenModal, keyUUID: keyUUID, keyName: keyName, appId: this.props.appId, serId: this.props.serviceId })));
    };
    return KeyTokenTableComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.keyToken; }, Stores.actionCreators)(KeyTokenTableComponent);
//# sourceMappingURL=KeyTokenTableComponent.js.map